<template>
  <v-navigation-drawer
    v-model="toggle"
    fixed
    app
    dark
    class="blue darken-4"
    height="100%"
    :key="this.getRol"
  >
    <v-toolbar text class="toolbar blue darken-4">
      <router-link
        :to="{ name: 'Home' }"
        style="width: 100%;display: flex; justify-content: center; align-items: center;"
      >
        <img src="../../assets/logo.png" width="65%" />
      </router-link>
    </v-toolbar>
    <v-list>
      <v-list-item @click="changeRoute('Home', 1)">
        <v-list-item-action> <v-icon>mdi-home</v-icon> </v-list-item-action>
        <v-list-item-title
          :class="[{ active: selectedIndex === 1 }, 'item-title']"
          >Home</v-list-item-title
        >
      </v-list-item>
      <v-list-group
        class="toolbar"
        :value="false"
        color="#fff"
        prepend-icon="mdi-priority-high"
        v-if="this.getRol == 'ROLE_ADMIN'"
      >
        <template v-slot:activator>
          <v-list-item-title>Gestión</v-list-item-title>
        </template>

        <!-- <v-list-item class="subItem" link @click="changeRoute('general', 2)">
           <v-list-item-title
            :class="[{ active: selectedIndex === 2 }, 'item-title']"
            >Órdenes de Trabajo</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-bookmark</v-icon> </v-list-item-icon>
        </v-list-item>
        <v-list-item class="subItem" link @click="changeRoute('historico', 3)">
          <v-list-item-title
            :class="[{ active: selectedIndex === 3 }, 'item-title']"
            >Histórico de Órdenes</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-bookmark-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item
          v-if="this.getRol != 'ROLE_TALLER'"
          class="subItem"
          link
          @click="changeRoute('estados', 4)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 4 }, 'item-title']"
            >Gestión de Estados</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-state-machine</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item
          v-if="this.getRol != 'ROLE_TALLER'"
          class="subItem"
          link
          @click="changeRoute('familiasMaterial', 5)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 5 }, 'item-title']"
            >Familias de Material</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-palette-swatch</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item
          v-if="this.getRol != 'ROLE_TALLER'"
          class="subItem"
          link
          @click="changeRoute('prioridades', 6)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 6 }, 'item-title']"
            >Gestión de Prioridades</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-arrow-up-down-bold</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item
          v-if="this.getRol != 'ROLE_TALLER'"
          class="subItem"
          link
          @click="changeRoute('tiposIncidencia', 7)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 7 }, 'item-title']"
            >Tipos de Incidencia</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-file-chart </v-icon>
          </v-list-item-icon>
        </v-list-item> -->

        <!-- href="https://produccion.upintelligence.es/" -->
        <v-list-item
         
          class="subItem"
          link
          href="https://ecommerce-jin.upintelligence.es/admin"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 2 }, 'item-title']"
            >CMS</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-cart</v-icon> </v-list-item-icon>
        </v-list-item>
        <v-list-item
          v-if="this.getRol == 'ROLE_ADMIN'"
          class="subItem"
          link
          @click="changeRoute('iot', 3)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 3 }, 'item-title']"
            >IoT</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-list-group class="toolbar" :value="false" color="#fff" sub-group>
          <template v-slot:activator>
            <v-list-item-title>Sistema de compras</v-list-item-title>
          </template>

          <v-list-item
            class="subItem"
            link
            @click="changeRoute('productosE', 8)"
          >
            <v-list-item-title
              :class="[{ active: selectedIndex === 8 }, 'item-title']"
              >Productos - Ecommerce</v-list-item-title
            >
            <v-list-item-icon>
              <v-icon>mdi-package-variant-closed</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item class="subItem" link @click="changeRoute('comprasE', 9)">
            <v-list-item-title
              :class="[{ active: selectedIndex === 9 }, 'item-title']"
              >Compras - Ecommerce</v-list-item-title
            >
            <v-list-item-icon>
              <v-icon>mdi-basket-fill</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
      </v-list-group>
      <v-list-group
        v-if="this.getRol != 'ROLE_TALLER'"
        class="toolbar"
        :value="false"
        color="#fff"
        prepend-icon="mdi-tray-full"
      >
        <template v-slot:activator>
          <v-list-item-title>Trazabilidad</v-list-item-title>
        </template>

        <v-list-item
          class="subItem"
          link
          @click="changeRoute('ubicaciones', 5)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 5 }, 'item-title']"
            >Ubicaciones</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-map-marker</v-icon> </v-list-item-icon>
        </v-list-item>
        <v-list-item
          class="subItem"
          link
          @click="changeRoute('proveedores', 6)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 6 }, 'item-title']"
            >Proveedores</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-store-marker</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item class="subItem" link @click="changeRoute('material', 7)">
          <v-list-item-title
            :class="[{ active: selectedIndex === 7 }, 'item-title']"
            >Gestión del Material</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-zip-box</v-icon> </v-list-item-icon>
        </v-list-item>

        <v-list-item class="subItem" link @click="changeRoute('compras', 10)">
          <v-list-item-title
            :class="[{ active: selectedIndex === 10 }, 'item-title']"
            >Compras</v-list-item-title
          >
          <v-list-item-icon>
            <v-icon>mdi-basket-fill</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item class="subItem" link @click="changeRoute('dashboard', 11)">
          <v-list-item-title
            :class="[{ active: selectedIndex === 11 }, 'item-title']"
            >Dashboard</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-chart-line</v-icon> </v-list-item-icon>
        </v-list-item>
        <v-list-item class="subItem" link @click="changeRoute('notas', 12)">
          <v-list-item-title
            :class="[{ active: selectedIndex === 12 }, 'item-title']"
            >Notas</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-note</v-icon> </v-list-item-icon>
        </v-list-item>
      </v-list-group>
      <v-list-item
        link
        target="_blank"
        href="https://www.juntasindustriales.com/es/"
      >
        <v-list-item-action> <v-icon>mdi-web</v-icon> </v-list-item-action>
        <v-list-item-title
          :class="[{ active: selectedIndex === 13 }, 'item-title']"
          >Web oficial</v-list-item-title
        >
      </v-list-item>

      <v-list-group
        class="toolbar"
        :value="false"
        color="#fff"
        prepend-icon="mdi-unity"
      >
        <template v-slot:activator>
          <v-list-item-title>Modelos 3D</v-list-item-title>
        </template>

        <v-list-item class="subItem" link @click="changeRoute('Almacen3D', 14)">
          <v-list-item-title
            :class="[{ active: selectedIndex === 14 }, 'item-title']"
            >Almacén 3D</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-equal-box</v-icon> </v-list-item-icon>
        </v-list-item>
        <v-list-item
          class="subItem"
          link
          @click="changeRoute('Maquinas3D', 15)"
        >
          <v-list-item-title
            :class="[{ active: selectedIndex === 15 }, 'item-title']"
            >Máquinas 3D</v-list-item-title
          >
          <v-list-item-icon> <v-icon>mdi-projector</v-icon> </v-list-item-icon>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import login from "../../services/Strapi";
export default {
  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: true,
      rol: null
    }
  },

  data() {
    return {
      selectedIndex: 1
    };
  },
  computed: {
    getRol() {
      console.log(this.$store.state.auth.user.roles[0]);
      return this.$store.state.auth.user.roles[0];
      // return this.$store.state.auth.user.roles[
      //   this.$store.state.auth.user.roles.length - 1
      // ];
    }
  },
  methods: {
    changeRoute(routeName, selectedIndex) {
      const vm = this;

      vm.selectedIndex = selectedIndex;

      return vm.$router.push({ name: routeName });
    },
    async autenticarEnStrapi() {
      this.$route;
      login();
    }
  }
};
</script>

<style>
.toolbar {
  font-weight: bold;
  font-size: 18px;
}

.toolbar .text {
  padding-left: 15px;
  color: white;
  text-decoration: none;
}

.item-title {
  font-size: 17px;
  font-weight: 500;
}
.item-sub-title {
  font-size: 15px;
  font-weight: 500;
}

.active {
  font-weight: bold;
}

div .vsheet {
  position: absolute;
  bottom: 0.1em;
  height: fit-content;
}

.logoAT_divided {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/core/NavigationDrawer.vue